"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var Divider_style_1 = __importDefault(require("./Divider.style"));
// To achieve spacings in an outer div paddings are used instead of margins to avoid potential
// margin collapses, so we can be sure that Divider will always create same space.
/**
 * Divider atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-divider--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Divider Source}
 */
var Divider = function (_a) {
    var className = _a.className, margin = _a.margin, vertical = _a.vertical;
    var classes = (0, Divider_style_1.default)();
    var _b = (0, lodash_1.defaultsDeep)(margin, vertical ? { top: 0, right: 16, bottom: 0, left: 16 } : { top: 16, right: 0, bottom: 16, left: 0 }), bottom = _b.bottom, left = _b.left, right = _b.right, top = _b.top;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(className, classes.root, vertical && classes.rootVertical), style: { paddingLeft: left, paddingRight: right, paddingTop: top, paddingBottom: bottom }, role: 'separator' }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, classnames_1.default)(classes.divider, vertical && classes.dividerVertical) }, { children: "\u00A0" })) })));
};
exports.Divider = Divider;
